// ----------------------------------------------------------------------
// V2 Design System — CssBaseline
// ----------------------------------------------------------------------

export function cssBaselineV2() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        // Chrome paints autofilled inputs with its own pale-yellow background, which
        // ignores the input tokens entirely. The inset shadow is the only way to
        // repaint it; white matches textFieldV2's `fill.enable`.
        'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
          {
            WebkitBoxShadow: '0 0 0 30px #ffffff inset !important',
            WebkitTextFillColor: 'inherit !important',
            // Long enough that the transition never actually reaches the UA color.
            transition: 'background-color 5000s ease-in-out 0s',
          },
      },
    },
  };
}
